import { useState } from "react";
import PublicService, { PublicServiceType } from "../../../service/public/PublicService";
import { useEffectOnce } from "../../../utils/Utils";

interface AddReviewerServiceType {
  openDialog: any;
  handleOpenDialog: any;
  handleCloseDialog: any;
  countryList: any;
}

export default function AddReviewerService(): AddReviewerServiceType {
  const { getCountryList, countryList }: PublicServiceType = PublicService();
  const [openDialog, setOpenDialog] = useState(false);

  useEffectOnce(() => {
    getCountryList();
  });

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return {
    openDialog,
    handleOpenDialog,
    handleCloseDialog,
    countryList,
  };
}

export type { AddReviewerServiceType };
